import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { Dossier } from "../../types/Dossier";

export const getMyDossiersForEmployerApproval = (
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossiers-for-approval"],
    queryFn: (): Promise<Dossier[]> => {
      return fetchWithAuth<Dossier[]>("getMyDossiersForEmployerApproval");
    },
    enabled: isQueryEnabled(options),
  });
};
